import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function getContractCenterData(id) {
  const query = `query ContractCenter(
    $id: ID
  ) {
    ContractCenter(id: $id) {

      contractData{ 
        rfq {
          all
          drafts
          submitted
          awarded
          requested
          archived
        }
        quotes {  
          all
          drafts
          submitted
          awarded
          requested
          archived
        }
      }
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response.ContractCenter.contractData;
}

// export async function createRFQ(userId) {
//   const query = `mutation createRFQ($userId: ID, $solNum: String, $participants: [String]) { createRFQ (userId: $userId, solNum: $solNum, participants: $participants) { status msg rfqId  } }`;

//   // Variables
//   const variables = { userId };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response;
// }

export async function archiveQuote(userId, rfqId, quoteId) {
  const query = `mutation archiveQuote($rfqId: Int, $userId: ID, $quoteId: Int,) { archiveQuote (rfqId: $rfqId, userId: $userId, quoteId: $quoteId) { status   } }`;

  const variables = { userId, rfqId, quoteId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function archiveRFQ(userId, rfqId) {
  const query = `mutation archiveRFQ($rfqId: Int, $userId: ID, ) { archiveRFQ (rfqId: $rfqId, userId: $userId, ) { status   } }`;

  const variables = { userId, rfqId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getDibbsQuote(userId, solicitationId) {
  const query = `query getDibbsQuote($userId: ID, $solicitationId: String) { getDibbsQuote(userId: $userId, solicitationId: $solicitationId) {dibbsQuoteValidationMsgsList msg
    dibbsPriceBreaksList
    dibbsProductsList
    dibbsContractInfo
    dibbsCompanyInfo
    dibbsLinesList
    dibbsQuote
    status }  }`;

  const variables = { userId, solicitationId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function validateDibbs(userId, solicitationId) {
  const query = `mutation validateDibbsQuote($userId: ID, $solicitationId: String) { validateDibbsQuote (userId: $userId, solicitationId: $solicitationId) { status, msg  } }`;

  // Variables
  const variables = { userId, solicitationId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function submitDibbs(userId, solicitationId) {
  const query = `mutation submitDibbsQuote($userId: ID, $solicitationId: String) { submitDibbsQuote (userId: $userId, solicitationId: $solicitationId) { status, msg  } }`;

  // Variables
  const variables = { userId, solicitationId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function updateDibbs(dibbs) {
  const query =
    'mutation updateDibbsQuote($dibbs: dibbsInput) { updateDibbsQuote (dibbs: $dibbs) {  status, msg  } }';

  // Variables
  const variables = { dibbs };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function ignoreDibbsQuoteWarning(userId, solicitationId) {
  const query = `mutation ignoreDibbsQuoteWarning($userId: ID, $solicitationId: String) { ignoreDibbsQuoteWarning (userId: $userId, solicitationId: $solicitationId) { status, msg  } }`;

  // Variables
  const variables = { userId, solicitationId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/graphql.js